module.exports = (__webpack_require__(0))(43);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/AccessControlledModel.js from dll-reference girder_lib
// module id = 22
// module chunks = 0